<template>
  <div class="chat-room-page">
    <div class="chat-header">
      <button class="chat-back-btn" @click="onBack">
        <van-icon name="arrow-left" />
      </button>
      <div class="chat-header-main">
        <div class="chat-title">{{ chatName }}</div>
        <div class="chat-subtitle">在线沟通中</div>
      </div>
    </div>

    <div class="message-area" ref="messageArea">
      <div class="message-list">
        <div v-for="(msg, index) in messages" :key="index"
          :class="['message-item', msg.senderType === currentUserType ? 'my-message' : 'other-message']">
            <div class="date-divider" v-if="showDateDivider(index)">{{ getDateLabel(index) }}</div>
          <div class="other-bubble" v-if="msg.senderType !== currentUserType">
            <div class="avatar" @click="goToOtherProfile(msg)">
              <van-image round width="40px" height="40px" :src="getAvatar(msg)" />
            </div>
            <div class="bubble-content">
              <template v-if="msg.messageType === 3">
                <div class="member-card-message" @click="openMemberCard(msg)">
                  <div class="member-card-title">嘉宾卡片</div>
                  <div class="member-card-body">
                    <van-image round width="56px" height="56px"
                      :src="getMemberCard(msg).avatarLink || defaultPhoto" />
                    <div class="member-card-info">
                      <div class="member-card-line">{{ getMemberCardName(msg) }}</div>
                      
                      <div class="member-card-line">{{ getMemberCardSummary(msg) }}</div>
                    </div>
                  </div>
                </div>
              </template>
              <div class="bubble-text" v-else>{{ msg.content }}</div>
              <div class="bubble-time">{{ getTimeStr(msg.createOn) }}</div>
            </div>
          </div>

          <div class="my-bubble" v-else>
            <div class="avatar" @click="jumpDetail(msg)">
              <van-image round width="40px" height="40px" :src="myAvatar" />
            </div>
            <div class="bubble-content">
              <template v-if="msg.messageType === 3">
                <div class="member-card-message member-card-message-mine" @click="openMemberCard(msg)">
                  <div class="member-card-title">嘉宾卡片</div>
                  <div class="member-card-body">
                    <van-image round width="56px" height="56px" :src="getMemberCard(msg).avatarLink || defaultPhoto" />
                    <div class="member-card-info">
                      <div class="member-card-line">{{ getMemberCardName(msg) }}</div>
                      
                      <div class="member-card-line">{{ getMemberCardSummary(msg) }}</div>
                    </div>
                  </div>
                </div>
              </template>
              <div class="bubble-text" v-else>{{ msg.content }}</div>
              <div class="bubble-time">{{ getTimeStr(msg.createOn) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="input-area">
      <van-field v-model="inputMessage" placeholder="请输入消息..." @keyup.enter="sendMessage" />
      <button class="send-btn" @click="sendMessage" :disabled="!inputMessage.trim()">发送</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Toast } from "vant";
import { getTimeStr } from "@/utils/tools";

export default {
  name: "ChatRoom",
  data() {
    return {
      conversationId: "",
      inputMessage: "",
      messages: [],
      chatName: "",
      otherAvatar: "",
      myAvatar: "",
      defaultPhoto: require("../assets/defaultPhoto.png"),
      currentUserType: "",
      refreshTimer: null
    };
  },
  computed: {
    ...mapGetters(["role", "baseInfo"])
  },
  created() {
    this.conversationId = this.$route.params.id;
    this.initChat();
  },
  mounted() {
    this.refreshTimer = setInterval(() => {
      this.loadMessages();
    }, 10000);
  },
  beforeDestroy() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  },
  methods: {
    ...mapActions(["GetMessages", "SendMessage", "MarkAsRead", "SetCurrentConversation"]),
    getTimeStr,
    showDateDivider(index) {
      if (index === 0) return true;
      return this.getDateKey(this.messages[index - 1].createOn) !== this.getDateKey(this.messages[index].createOn);
    },
    getDateLabel(index) {
      const d = new Date(this.messages[index].createOn);
      if (isNaN(d.getTime())) return "";
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const day = new Date(d.getFullYear(), d.getMonth(), d.getDate());
      const diffDays = Math.round((today - day) / 86400000);
      if (diffDays === 0) return "今天";
      if (diffDays === 1) return "昨天";
      if (d.getFullYear() === now.getFullYear()) {
        return `${d.getMonth() + 1}月${d.getDate()}日`;
      }
      return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`;
    },
    getDateKey(dateStr) {
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return "";
      return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
    },
    async initChat() {
      this.currentUserType = this.role === "Member" ? "Member" : "Matchmaker";

      if (this.role === "Member") {
        this.chatName = this.$route.query.matchmakerName || "红娘";
        this.otherAvatar = this.$route.query.matchmakerAvatar || "";
        this.myAvatar = (this.baseInfo && this.baseInfo.avatarLink) || "";
      } else {
        this.chatName = this.$route.query.memberName || "会员";
        this.otherAvatar = this.$route.query.memberAvatar || "";
        this.myAvatar = (this.baseInfo && this.baseInfo.avatarLink) || "";
      }

      await this.loadMessages();
      this.MarkAsRead(this.conversationId);
    },
    async loadMessages() {
      try {
        const res = await this.GetMessages(this.conversationId);
        this.messages = res || [];
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      } catch (error) {
        console.error("获取消息历史失败:", error);
      }
    },
    async sendMessage() {
      if (!this.inputMessage.trim()) return;

      try {
        await this.SendMessage({
          conversationId: this.conversationId,
          content: this.inputMessage.trim(),
          messageType: 1
        });
        this.inputMessage = "";
        await this.loadMessages();
      } catch (error) {
        Toast.fail("发送失败");
        console.error("发送消息失败:", error);
      }
    },
    onBack() {
      this.$router.back();
    },
    scrollToBottom() {
      const messageArea = this.$refs.messageArea;
      if (messageArea) {
        messageArea.scrollTop = messageArea.scrollHeight;
      }
    },
    getAvatar(msg) {
      // 优先使用后端返回的签名头像URL
      if (msg.senderAvatar) {
        return msg.senderAvatar;
      }
      // 兼容旧逻辑
      if (msg.senderType === "Member") {
        return this.$route.query.memberAvatar || "";
      } else {
        return this.$route.query.matchmakerAvatar || "";
      }
    },
    getMemberCard(msg) {
      if (!msg || !msg.payloadJson) return {};
      try {
        return JSON.parse(msg.payloadJson);
      } catch (error) {
        return {};
      }
    },
    getMemberCardName(msg) {
      // 嘉宾卡片名称：只认 nickName，没有则展示编号
      const card = this.getMemberCard(msg);
      if (card.nickName) return card.nickName;
      return card.serialNumber ? `编号${card.serialNumber}` : "会员";
    },
    getMemberCardSummary(msg) {
      const card = this.getMemberCard(msg);
      const summary = [];
      if (card.sex === 1 || card.sex === 2) {
        summary.push(card.sex === 1 ? "男" : "女");
      }
      if (card.height) {
        summary.push(`${card.height}CM`);
      }
      if (card.education) {
        const educationData = ["大专", "本科", "硕士", "博士", "高中及以下"];
        summary.push(educationData[card.education - 1] || "");
      }
      return summary.filter(Boolean).join(" / ") || (card.hometown || "点击查看详情");
    },
    goToOtherProfile(msg) {
      if (msg.senderType == "Matchmaker") {
        this.$router.push({ path: `/excellentMatchmaker/${msg.senderId}` });
      } else {
        this.$router.push({ path: `/detailInformation/${msg.senderId}` });
      }
      return false;
      // 获取对方ID进行跳转：优先使用消息中的senderId，其次根据当前角色取路由参数
      let otherId = (msg && msg.senderId) || null;
      if (!otherId) {
        if (this.role === "Member") {
          // 当前用户是会员，对方是红娘
          otherId = this.$route.query.matchmakerId;
        } else {
          // 当前用户是红娘，对方是会员
          otherId = this.$route.query.memberId;
        }
      }
      if (otherId) {
        if (this.role === "Member") {
          // 会员查看红娘名片 → 跳红娘详情页
          this.$router.push({ path: `/excellentMatchmaker/${otherId}` });
        } else {
          // 红娘查看会员名片 → 跳会员详情页
          this.$router.push({ path: `/detailInformation/${otherId}` });
        }
      }
    },
    openMemberCard(msg) {
      const card = this.getMemberCard(msg);
      const memberId = card.memberId || card.id;
      if (!memberId) return;
      this.$router.push({ path: `/detailInformation/${memberId}` });
    },
    jumpDetail(msg) {
      if (msg.senderType == "Matchmaker") {
        this.$router.push({ path: `/excellentMatchmaker/${msg.senderId}` });
      } else {
        this.$router.push({ path: `/detailInformation/${msg.senderId}` });
      }
    }
  }
};
</script>

<style scoped lang="less" src="../style/chatRoom.less" />



// WEBPACK FOOTER //
// src/views/chatRoom.vue